/* src/app/acs-chat/components/message-list/message-list.scss */
:host {
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  min-height: 0;
}
.message-list {
  flex: 1;
  overflow-y: auto;
  padding: 8px 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
  background: #fafafa;
  scrollbar-width: thin;
  scrollbar-color: rgba(0, 0, 0, 0.2) transparent;
}
.message-list::-webkit-scrollbar {
  width: 6px;
}
.message-list::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 4px;
}
.date-separator {
  display: flex;
  align-items: center;
  margin: 16px 16px 8px;
  gap: 10px;
}
.date-separator::before,
.date-separator::after {
  content: "";
  flex: 1;
  height: 1px;
  background: #c5886d;
}
.date-separator span {
  padding: 0 4px;
  font-size: 12px;
  color: #c5886d;
  font-weight: 500;
  white-space: nowrap;
}
/*# sourceMappingURL=message-list.css.map */
